import { lazy } from "react";
import { Outlet } from "react-router-dom";

const UserLoginPage = lazy(() => import("../pages/login"));
const EmailVerificationResultPage = lazy(() =>
  import("../pages/onboarding/verification")
);

const PolicyPage = lazy(() => import("../pages/policy"));

export const publicRoutes = [
  {
    path: "login",
    element: <UserLoginPage />,
  },
  {
    path: "policy",
    element: <PolicyPage />,
  },
  {
    path: "onboarding",
    element: <Outlet />,
    children: [{ path: "verify", element: <EmailVerificationResultPage /> }],
  },
];
